export const CheckSVG = () => {
  return (
    <svg
      className="scale-125"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M19 7L9.375 16.625L5 12.25" stroke="#3C4D6A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
